class FormFunction {
    constructor() {
        // General Variables
        this.errorCloseBtn = document.querySelector("[close-message-btn]")
        this.deleteUploadBtn = document.querySelector("[data-upload-delete-btn]")

        // DATE FORM FUNCTIONING
        // Date of Birth Functioning
        this.hiddenCont = document.querySelector("[data-hidden-dob]").children
        this.dobField = document.querySelector("[data-dob-field]")
        this.dobUpdate()

        // PHONE NUMBER FUNCTIONING
        // Phone Number Formatting
        this.phoneInputs = document.querySelectorAll("input[type='tel']")
        this.phoneNumberFormatting()

        // MORE INFORMATION FUNCTIONING
        // More Information Button/Popup Functioning
        this.moreInfoBtns = document.querySelectorAll("[data-more-info-btn]")
        this.setAcceptedFiles()

        // UPLOAD FUNCTIONING
        // Prescription Radio Buttons for Upload Functioning
        this.scriptRadios = document.querySelector("[data-script-btn-wrappers]").querySelectorAll("input")
        this.scriptRadioUpdate()

        // Presciption Drag and Drop for Upload Functioning
        this.dragDropUpload = document.querySelector("[data-drag-drop-upload]")
        this.dndUploadUpate()

        // Prescription Browse Files Upload Functioning
        this.uploadUpdate()

        // Text Area Char Counting Functioning
        this.textAreaCharCounting()

        // INSURANCE FUNCTIONING
        // Insurance Radio Buttons for Secondary and Tertiary Functioning
        this.secondaryRadios = document.querySelector("[data-secondary-btn-wrappers]").querySelectorAll("input")
        this.secondaryRadioUpdate()
        this.tertiaryRadios = document.querySelector("[data-tertiary-btn-wrappers]").querySelectorAll("input")
        this.tertiaryRadioUpdate()

        // FORM PROGRESS BAR FUNCTIONING
        // Progress Bar Variables
        this.submitBtn = document.querySelector("[data-form-submit-btn]")
        this.progressSlide = document.querySelector("[data-progress-bar-component-slider]")
        this.requiredInputs = document.querySelectorAll("[data-required-input]:not(.hidden)")
        this.percentDiv = document.querySelector("[data-completion-percentage]")
        this.countDiv = document.querySelector("[data-completion-count]")
        this.requiredInputCount = this.requiredInputs.length
        this.percentComplete = 0
        this.formsCompleted = 0

        // FORM ACKOWLEDGEMENT FUNCTIONING
        // Ackowledgement Buttons Variable
        this.ackowledgementBtns = document.querySelectorAll("[data-acknowledgement-btn]")
        this.modalFunctioning()
        this.acknowledgement = [false, false]
        
        window.addEventListener("load", (event) => {
            this.errorCloseBtn.addEventListener("click", (event) => {
                this.closeError()
            })

            this.deleteUploadBtn.addEventListener("click", (event) => {
                let temp = document.querySelector("[data-upload-input]")
                this.deleteUpload(temp)
            })

            this.setProgress()
            this.updateInputObjArray()

            this.inputArray.forEach(inputLine => {
                inputLine.forEach(formInput => {
                    formInput.addEventListener("change", (event) => {
                        this.refreshRequiredInputs()
                    })
                })
            })

            this.setMinMaxDate()
            this.moreInfoBtnClick()
        })

    }
    
    setMinMaxDate() {
        let currentDate = new Date()
        const offset = currentDate.getTimezoneOffset()
        currentDate = new Date(currentDate.getTime() - (offset*60*1000))
        currentDate = currentDate.toISOString().split('T')[0]
        let minDate = currentDate.split("-")
        minDate[0] = `${parseInt(minDate[0] - 125)}`
        minDate = minDate.join("-")

        this.dobField.setAttribute("min", minDate)
        this.dobField.setAttribute("max", currentDate)
    }

    dobUpdate() {
        this.dobField.addEventListener("change", (event) => {
            var tempArr = event.target.value.split("-")
            Array.from(this.hiddenCont).forEach(cont => {
                if(cont.name.includes("day")) {
                    cont.value = tempArr[2]
                } else if(cont.name.includes("month")) {
                    cont.value = tempArr[1]
                } else if(cont.name.includes("year")) {
                    cont.value = tempArr[0]
                }
            })
        })
    }

    phoneNumberFormatting() {
        this.phoneInputs.forEach(phoneInput => {
            phoneInput.addEventListener("keypress", (event) => {
                if(!event.code.includes("Digit")) {
                    event.preventDefault()
                } else {
                    if(event.target.value.length === 0 || window.getSelection().toString() == event.target.value)
                        event.target.value = "("
                    else if(event.target.value.length === 4)
                        event.target.value += ") "
                    else if(event.target.value.length === 9)
                        event.target.value += "-"
                }

            })
        })
    }

    setAcceptedFiles() {
        let acceptedTypes = document.querySelector("[data-accepted-file-types]")
        let temp = document.querySelector("[type='file'").getAttribute("data-file-accept")

        acceptedTypes.innerHTML = `Accepted Files: ${temp}`

    }

    moreInfoBtnClick() {
        this.moreInfoBtns.forEach(moreInfobtn => {
            moreInfobtn.addEventListener("click", (event) => {
                let moreInfoName = event.target.getAttribute("data-more-info-btn")
                if(moreInfoName === "open")
                    event.target.parentNode.parentNode.querySelector("[data-more-info-popup]").classList.toggle("hidden")
                else if(moreInfoName === "close") {
                    event.target.parentNode.classList.toggle("hidden")
                }
            })
        })
    }

    scriptRadioUpdate() {
        let temp0 = document.querySelector("[data-prescription-text-content]")
        let temp1 = document.querySelector("[data-prescription-upload-component]")
        this.scriptRadios.forEach(radioBtn => {
            radioBtn.addEventListener("change", (event) => {
                if(event.target.value === "Yes") {
                    temp0.classList.add("hidden")
                    temp1.classList.remove("hidden")
                } else {
                    temp0.classList.remove("hidden")
                    temp1.classList.add("hidden")
                }
            })
        })
    }

    dndUploadUpate() {
        let temp = document.querySelector("[data-upload-input]")
        this.dragDropUpload.addEventListener("dragover", (event) => {
            event.preventDefault()
        })
        this.dragDropUpload.addEventListener("drop", (event) => {
            event.preventDefault()
            temp.files = event.dataTransfer.files

            this.uploadFile(temp)
        })
        this.dragDropUpload.addEventListener("keydown", (event) => {
            if(event.key != "Tab")
                event.preventDefault()
            if(event.key === " " || event.key === "Enter")
                $j("[data-upload-input]").trigger('click')
        })
    }

    uploadUpdate() {
        let temp = document.querySelector("[data-upload-input]")
        temp.addEventListener("change", () => {
            this.uploadFile(temp)
        })
    }

    fileSize(uploadSize) {
        let newSize 
        if(uploadSize/1024 < 1024) {
            newSize = `${(uploadSize/1024).toFixed(2)} KB`
        } else if(uploadSize/1048576 < 1024) {
            newSize = `${(uploadSize/1048576).toFixed(2)} MB`
        }

        return newSize
    }

    fileName(uploadName) {
        let temp = uploadName.split("")
        let indexes = [undefined, undefined, undefined]
        let count = uploadName.length

        temp.forEach((letter, IDX) => {
            if((letter === " " || letter === "-" || letter === "_" || letter === ")") && indexes[0] === undefined) 
                indexes[0] = IDX

            if((temp[count] === " " || temp[count] === "-" || temp[count] === "_" || temp[count] === "(") && indexes[1] === undefined) 
                indexes[1] = count + 1

            if((temp[count] === "." && indexes[2] === undefined)) 
                indexes[2] = count

            if(indexes[1] === undefined)
                count--
       })

       if(indexes[0] != undefined && indexes[1] != undefined) {
            temp.splice(indexes[0], indexes[1] - indexes[0])
            temp.splice(indexes[0], 0, ".", ".", ".")
        } else {
            temp.splice(5, (indexes[2] - 5) - 5)
            if(temp.length > 15)
                temp.splice(5, 0, ".", ".", ".")
        }

        temp = temp.join("")
        return temp
    }

    uploadFile(input) {
        let uploadDescription = document.querySelector("[data-upload-description]")
        let errorContainer = document.querySelector("[data-upload-error-container]")
        let sizePassed = this.sizeCheck(input)
        let fileTypePassed = this.fileTypeCheck(input)
        if(sizePassed && fileTypePassed) {
            if(!errorContainer.classList.contains("hidden"))
                errorContainer.classList.add("hidden")
            let fileInfo = document.querySelectorAll("[data-upload-file-info")
            uploadDescription.classList.remove("hidden")
            fileInfo.forEach(value => {
                let valueName = value.getAttribute("data-upload-file-info")
                if(valueName === "title") {
                    value.innerHTML = this.fileName(input.files[0].name)
                } else if(valueName === "size") {
                    value.innerHTML = this.fileSize(input.files[0].size)
                }
            })
        } else {
            if(!uploadDescription.classList.contains("hidden"))
                uploadDescription.classList.add("hidden")
            let errorDescription = document.querySelectorAll("[data-upload-error-message]")
            errorContainer.classList.remove("hidden")

            errorDescription.forEach(description => {
                let descriptionName = description.getAttribute("data-upload-error-message")
                if(sizePassed === false) {
                    if(descriptionName === "file-error") {
                        description.innerHTML = "File size is too large..."
                    } else if(descriptionName === "file-limit-type") {
                        description.innerHTML = `File Limit: ${parseFloat(input.getAttribute("data-file-maxsize")/1024)} MB`
                    }
                } else if(fileTypePassed === false) {
                    if(descriptionName === "file-error") {
                        description.innerHTML = `Accepted file types: ${input.getAttribute("data-file-accept")}`
                    }
                } else {

                }

            })
            input.value = ""
        }
        
    }

    sizeCheck(input) {
        let maxSize = parseFloat(input.getAttribute("data-file-maxsize"))
        let currentSize = input.files[0].size/1024

        if(currentSize <= maxSize) {
            return true;
        } else {
            return false;
        }
    }

    fileTypeCheck(input) {
        let acceptedTypes = input.getAttribute("data-file-accept").split(", ")
        let tempBool = false
        let tempStrArr = input.files[0].name.split(".")

        let currentType = tempStrArr[tempStrArr.length - 1]
        
        acceptedTypes.forEach(acceptedType => {
            if(currentType === acceptedType) {
                tempBool = true
                return true
            }
        })
        return tempBool
    }

    deleteUpload(input) {
        input.value = ""
        let fileInfo = document.querySelectorAll("[data-upload-file-info")
        fileInfo.forEach(value => {
            value.innerHTML = ""
        })
        let uploadDescription = document.querySelector("[data-upload-description]")
        uploadDescription.classList.add("hidden")
    }

    closeError() {
        let errorDescription = document.querySelectorAll("[data-upload-error-message]")
        let errorContainer = document.querySelector("[data-upload-error-container]")

        errorDescription.forEach(description => {
            description.innerHTML = ""
        })
        errorContainer.classList.add("hidden")
    }

    textAreaCharCounting() {
        var testVar = document.querySelector("[data-textarea-char-count-container]")
        var textArea = document.querySelector("[data-textarea-input]")
        testVar.innerHTML = `0/${textArea.maxLength}`

        textArea.addEventListener("keyup", (event) => {
            testVar.innerHTML = `${event.target.value.length}/${textArea.maxLength}`
        })

        textArea.addEventListener("keydown", (event) => {
            if(event.key === "Backspace" || event.key === "Delete")
                testVar.innerHTML = `${event.target.value.length}/${textArea.maxLength}`
        })
    }

    secondaryRadioUpdate() {
        let temp0 = document.querySelector("[data-secondary-insurace-inputs]")
        let temp1 = document.querySelector("[data-tertiary-insurace-radios]")
        let temp2 = document.querySelector("[data-tertiary-insurance-inputs]")
        let temp3 = document.querySelectorAll("[data-secondary-insurace-inputs] input, [data-tertiary-insurance-inputs] input")
        let tertiaryRadio = document.querySelector("[data-tertiary-radio-btn]")

        this.secondaryRadios.forEach(radioBtn => {
            radioBtn.addEventListener("change", (event) => {
                if(event.target.value === "Yes") {
                    temp0.classList.remove("hidden")
                    temp1.classList.remove("hidden")
                    if(!tertiaryRadio.checked)
                        temp2.classList.remove("hidden")

                    temp3.forEach(input => {
                        input.required = true
                    })
                } else if(event.target.value === "No") {
                    temp0.classList.add("hidden")
                    temp1.classList.add("hidden")
                    temp2.classList.add("hidden")

                    temp3.forEach(input => {
                        input.required = false
                    })
                }
                this.refreshRequiredInputs()
                this.inputArray.forEach(inputLine => {
                    inputLine.forEach(formInput => {
                        formInput.addEventListener("change", (event) => {
                            this.refreshRequiredInputs()
                        })
                    })
                })
            })
        })
    }

    tertiaryRadioUpdate() {
        let temp = document.querySelector("[data-tertiary-insurance-inputs]")
        let tempInput = document.querySelectorAll("[data-tertiary-insurance-inputs] input")

        this.tertiaryRadios.forEach(radioBtn => {
            radioBtn.addEventListener("change", (event) => {
                if(event.target.value === "Yes") {
                    temp.classList.remove("hidden")

                    tempInput.forEach(input => {
                        input.required = true
                    })
                } else if(event.target.value === "No") {
                    temp.classList.add("hidden")

                    tempInput.forEach(input => {
                        input.required = false
                    })
                }
                this.refreshRequiredInputs()
                this.inputArray.forEach(inputLine => {
                    inputLine.forEach(formInput => {
                        formInput.addEventListener("change", (event) => {
                            this.refreshRequiredInputs()
                        })
                    })
                })
            })
        })
    }

    setProgress() {
        this.percentDiv.innerHTML = `${this.percentComplete}% Completed`
        this.countDiv.innerHTML = `Completed ${this.formsCompleted}/${this.requiredInputCount}`
        this.progressSlide.style.transform = `translate(${this.percentComplete}%)`

        if(this.percentComplete == 100.00) {
            this.enableSubmitBtn()
        } else if (this.percentComplete < 100 && !this.submitBtn.disabled) {
            this.disableSubmitBtn()
        }
    }

    refreshRequiredInputs() {
        this.requiredInputs = document.querySelectorAll("[data-required-input]:not(.hidden)")
        this.requiredInputCount = this.requiredInputs.length
        this.updateInputObjArray()
        this.setProgress()
    }

    updateInputObjArray() {
        this.inputArray = []
        this.requiredInputs.forEach(inputLine => {
            let temp = []
            inputLine.querySelectorAll("[required]").forEach(input => {
                temp.push(input)
            })
            this.inputArray.push(temp)
            temp = []
        })
        this.updateValidInputsArray()
    }

    updateValidInputsArray() {
        this.validInputArray = []
        this.inputArray.forEach(inputLine => {
            let temp = []
            inputLine.forEach((input, IDX) => {
                let inputType = input.getAttribute("type")
                if(inputType === "checkbox") {
                    temp.push(input.checked)
                } else {
                    temp.push(input.checkValidity())
                }
            })
            temp = temp.every(Boolean)
            this.validInputArray.push(temp)
        })
        this.updateValidInputCount()
    }

    updateValidInputCount() {
        let count = 0
        this.validInputArray.forEach(input => {
            if(input === true)
                count++
        })
        this.formsCompleted = count
        if(count === 0)
            this.percentComplete = 0
        else
            this.percentComplete = ((count/this.validInputArray.length)*100).toFixed(2)

    }

    enableSubmitBtn() {
        if(this.submitBtn.disabled)
            this.submitBtn.disabled = false
    }

    disableSubmitBtn() {
        if(!this.submitBtn.disabled)
            this.submitBtn.disabled = true
    }

    modalFunctioning() {
        this.ackowledgementBtns.forEach(acknowledgementBtn => {
            acknowledgementBtn.addEventListener("click", (event) => {
                let btnName = event.target.getAttribute("data-acknowledgement-btn")
                this.getPageInformation(btnName)
            })
        })
        
    }

    createModal(btnName) {
        const newDiv = $j('<div/>', {
            "class": `ackowledgement-modal-container ${btnName}`,
            "data-modal-container": ""
        })

        let titleText
        if(btnName === "right") {
            titleText = "Your Rights as a Patient"
        } else if(btnName === "notice") {
            titleText = "Notice of Uses"
        }

        newDiv.append($j('<button/>', {
            "class": "modal-close-btn",
            "type": "button",
            "data-modal-close-btn": "",
            text: "X"
        }))

        newDiv.append($j('<h2/>', {
            "class": "policy-modal-title",
            text: titleText
        }))


        newDiv.append($j('<div/>', {
            "class": "modal-content-wrapper",
            "data-modal-content-element": ""
        }))

        let agreedIDX
        if(btnName === "right") {
            agreedIDX = 0
        } else if(btnName === "notice") {
            agreedIDX = 1
        }

        newDiv.append($j('<button/>', {
            "class": "agreement-btn",
            text: "I have read and understand",
            "data-modal-agreement-btn": "",
            "data-agreement-id": `${agreedIDX}`
        }))

        return newDiv
    }

    getPageInformation(btnName) {
        let pageHandle
        if(btnName === "right") {
            pageHandle = '/pages/your-rights-as-a-patient'
        } else if(btnName === "notice") {
            pageHandle = '/pages/notice-of-uses'
        }

        let _this = this

        $j.get(pageHandle, function(data) {
            var dataHTML = $j(data).find("[data-policy-information]").html()
            _this.injectPageInformation(dataHTML, _this.createModal(btnName))
            document.body.classList.add("no-scroll")
        })
    }

    injectPageInformation(rawHTMLData, element) {
        element.find("[data-modal-content-element]").append(rawHTMLData)
        element.appendTo('[data-main-section]')

        let closeBtn = document.querySelector("[data-modal-close-btn]")
        let agreementBtn = document.querySelector("[data-modal-agreement-btn]")

        closeBtn.addEventListener("click", (event) => {
            this.agreementClose()
        })

        agreementBtn.addEventListener("click", (event) => {
            this.agreementClose()
            this.acknowledgement[parseInt(event.target.getAttribute("data-agreement-id"))] = true

            let temp = document.querySelector("[data-acknowledgement-input]")
            if(this.acknowledgement.every(Boolean)) {
                temp.checked = true
                temp.disabled = false
                this.refreshRequiredInputs()
            }
        })
        agreementBtn.addEventListener("keydown", (event) => {
            if(event.key === " " || event.key === "Enter") {
                event.preventDefault()
                this.agreementClose()
                this.acknowledgement[parseInt(event.target.getAttribute("data-agreement-id"))] = true

                let temp = document.querySelector("[data-acknowledgement-input]")
                if(this.acknowledgement.every(Boolean)) {
                    temp.checked = true
                    temp.disabled = false
                    this.refreshRequiredInputs()
                }
            }
        })
    }

    agreementClose() {
        let temp = document.querySelector("[data-modal-container]")
            temp.classList.add("hidden")

            temp.remove()
            document.body.classList.remove("no-scroll")
    }
}

$j = jQuery.noConflict()
const formFunction = new FormFunction()